<template>
  <div class="head-page">
    <Header :title="$t('member.my_promotion_code')" />
    <div class="invite-box">
      <div class="invite-qrcode">
        <QRCode ref="qrcode" />
      </div>
      <p>{{ $t('member.promotion_code') }} {{ invite }}</p>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { QRCode } from "./components/index";
export default {
  name: "MyInvite",
  components: { Header, QRCode },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      invite: null,
      address: null,
    };
  },
  mounted() {
    this.invite = this.$route.query.code;
    this.address = this.safeWapConfig.invit_url+ "?invite=" + this.invite;
    this.$refs.qrcode.text = this.address;
    this.$refs.qrcode.generateQRCode();
  },
};
</script>

<style>
</style>
